import {
  getQueryStringParameter,
  clearInputField
} from "../../../helpers";

import { setupFatcaFiscalCountries } from "../fatca_nif_inputs";

$(document).ready(() => {
  const $form = $("form#legal-profile-form");
  const step = getQueryStringParameter("id");

  if ($form.length === 0 || step !== "tax_details") {
    return;
  }

  setupFatcaFiscalCountries($form);

  const $accountHolderStatusRadioButtons = $("#account-holder-status-radio-buttons input[type=radio]", $form);
  const $financialInstitutionTypeFields = $("#financial-institution-type-fields", $form);
  const $activeNfeFields = $("#active-nfe-fields", $form);

  $accountHolderStatusRadioButtons.on("change", (e) => {
    if (e.target.value === "financial_institution") {
      if (e.target.checked) {
        $activeNfeFields.addClass("d-none");
        $financialInstitutionTypeFields.removeClass("d-none");

        $("input", $activeNfeFields).each((_, inputElement) => {
          clearInputField(inputElement);
        });
      } else {
        $financialInstitutionTypeFields.addClass("d-none");

        $("input", $financialInstitutionTypeFields).each((_, inputElement) => {
          clearInputField(inputElement);
        });
      }
    } else if (e.target.value === "active_nfe") {
      if (e.target.checked) {
        $financialInstitutionTypeFields.addClass("d-none");
        $activeNfeFields.removeClass("d-none");

        $("input", $financialInstitutionTypeFields).each((_, inputElement) => {
          clearInputField(inputElement);
        });
      } else {
        $activeNfeFields.addClass("d-none");

        $("input", $activeNfeFields).each((_, inputElement) => {
          clearInputField(inputElement);
        });
      }
    } else if (e.target.value === "passive_nfe" && e.target.checked) {
      $activeNfeFields.addClass("d-none");
      $financialInstitutionTypeFields.addClass("d-none");

      $("input", $activeNfeFields).each((_, inputElement) => {
        clearInputField(inputElement);
      });

      $("input", $financialInstitutionTypeFields).each((_, inputElement) => {
        clearInputField(inputElement);
      });
    }
  });

  const $atad2Section = $("#atad2-section", $form);
  const $atad2TransparentWarning = $("#atad2-transparent-warning", $form);
  const $atad2TaxableFields = $("#atad2-taxable-fields", $form);
  const $atad2NotTaxableFields = $("#atad2-not-taxable-fields", $form);
  const $atad2ActingTogetherField = $("#atad2-acting-together-partner-names-field", $form);

  const clearInputs = ($container) => {
    $("input", $container).each((_, inputElement) => {
      clearInputField(inputElement);
    });

    $("textarea", $container).each((_, inputElement) => {
      clearInputField(inputElement);
    });
  };

  $form.on("change", "select.fatca_fiscal_country", (e) => {
    if (!e.target.name.endsWith("[fatca_first_fiscal_country]")) {
      return;
    }

    const value = e.target.value;

    if (value === "" || value === "FR") {
      $atad2Section.addClass("d-none");
      clearInputs($atad2Section);
      $atad2TransparentWarning.addClass("d-none");
      $atad2TaxableFields.addClass("d-none");
      $atad2NotTaxableFields.addClass("d-none");
      $atad2ActingTogetherField.addClass("d-none");
    } else {
      $atad2Section.removeClass("d-none");
    }
  });

  const $atad2FundTaxTreatmentRadios = $(
    "#atad2-fund-tax-treatment-radio-buttons input[type=radio]",
    $form
  );

  $atad2FundTaxTreatmentRadios.on("change", (e) => {
    if (!e.target.checked) return;

    if (e.target.value === "transparent") {
      $atad2TransparentWarning.removeClass("d-none");
    } else {
      $atad2TransparentWarning.addClass("d-none");
    }
  });

  const $atad2LimitedPartnerTaxTreatmentRadios = $(
    "#atad2-limited-partner-tax-treatment-radio-buttons input[type=radio]",
    $form
  );

  $atad2LimitedPartnerTaxTreatmentRadios.on("change", (e) => {
    if (!e.target.checked) return;

    if (e.target.value === "taxable") {
      $atad2TaxableFields.removeClass("d-none");
      $atad2NotTaxableFields.addClass("d-none");
      clearInputs($atad2NotTaxableFields);
    } else if (e.target.value === "not_taxable") {
      $atad2NotTaxableFields.removeClass("d-none");
      $atad2TaxableFields.addClass("d-none");
      clearInputs($atad2TaxableFields);
    }
  });

  const $atad2ActsTogetherRadios = $(
    "#atad2-acts-together-radio-buttons input[type=radio]",
    $form
  );

  $atad2ActsTogetherRadios.on("change", (e) => {
    if (!e.target.checked) return;

    if (e.target.value === "true") {
      $atad2ActingTogetherField.removeClass("d-none");
    } else {
      $atad2ActingTogetherField.addClass("d-none");
      clearInputs($atad2ActingTogetherField);
    }
  });

  const $pillar2AdditionalQuestions = $("#pillar2-additional-questions", $form);
  const $pillar2InJurisdictionRadios = $(
    "#pillar2-in-pillar2-jurisdiction-radio-buttons input[type=radio]",
    $form
  );

  $pillar2InJurisdictionRadios.on("change", (e) => {
    if (!e.target.checked) return;

    if (e.target.value === "true") {
      $pillar2AdditionalQuestions.removeClass("d-none");
    } else {
      $pillar2AdditionalQuestions.addClass("d-none");
      clearInputs($pillar2AdditionalQuestions);
    }
  });
});
